import Header from './components/Header';
import Hero from './components/Hero';
import CapabilitiesStrip from './components/CapabilitiesStrip';
import WhyRG from './components/WhyRG';
import Services from './components/Services';
import HowWeWork from './components/HowWeWork';
import SelectedWork from './components/SelectedWork';
import Proof from './components/Proof';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="bg-brand-bg text-brand-text font-sans">
      <Header />
      <main>
        <Hero />
        <CapabilitiesStrip />
        <WhyRG />
        <Services />
        <HowWeWork />
        <SelectedWork />
        <Proof />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
